import { useEffect, useState } from 'react';

const useResizeObserver = (ref: any) => {
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    if (!ref?.current) return;

    const observer = new ResizeObserver((entries) => {
      const { contentRect } = entries[0];
      setSize({
        width: contentRect.width,
        height: contentRect.height,
      });
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.current]);

  return size;
};

export default useResizeObserver;
